export const PRODUCTS = {
    LOAD: 'PRODUCTS_LOAD',
    LOAD_FAILED: 'PRODUCTS_LOAD_FAILED',
    LOAD_DONE: 'PRODUCTS_LOAD_DONE'
}

export const loadProducts = (type, payload) => ({
    type: !type? PRODUCTS.LOAD: type,
    payload
})